'use strict'

export default class Products
{
    constructor()
    {
        this.$elem = $('.Single.Products')

        if( this.$elem.length > 0 ){
            let self = this
            
            $(document).ready(function(){
                self.slideVarieties = {}
                self._varieties()
            })
        }
    }

    _varieties(){
        let self = this
        let $varieties =  self.$elem.find('.Products__container__various')
        let $sidebar = $('.Single .Sidebar')
        
        let resizerBox = () => {
            if( window.innerWidth >= 1200 ){
                if( $varieties.hasClass('-full') ){
                    $varieties.removeClass('-full')
                }
                
                let valueWidth = 0
                if( !$sidebar.hasClass('show_complete') ){
                    valueWidth = window.innerWidth - 70
                } else{
                    valueWidth = window.innerWidth - $sidebar.outerWidth()
                }

                $varieties.css({
                    'max-width' : valueWidth
                })
                
            } else{
                if( !$varieties.hasClass('-full') ){
                    $varieties.addClass('-full', 300, 'swing')
                }
            }
        }
        resizerBox()

        let $items = $varieties.find('.Variety:not(.-block)')
        let itemsToShow = 0

        let generatorSlide = () => {
            if( window.innerWidth >= 1200 ){
                itemsToShow = 4
            } else if( window.innerWidth < 1200 && window.innerWidth >= 900 ){
                itemsToShow = 3
            } else{
                if( window.innerWidth >= 500 ){
                    itemsToShow = 2
                } else{
                    itemsToShow = 1
                }
            }

            if( $items.length <= itemsToShow ) {
                $varieties.addClass('without-slide grid-noGutter-top-left')
                $varieties.find('.Variety').addClass('col')

                let count = 0
                let controller = setInterval(function(){
                    if( $varieties.find('.Variety.-block').length > 0 ){
                        $varieties.find('.Variety.-block').css({
                            'height' : $items.first().outerHeight()
                        })
                    }

                    count++;

                    if( count == 3 ){
                        clearInterval(controller)
                    }
                }, 300)
                
                return false
            }

            $items.addClass('swiper-slide')
            $varieties.addClass('with-slide')
            $varieties.append('<div class="swiper-wrapper"></div>')        
            let $container = $varieties.find('.swiper-wrapper')
            $varieties.append(`<a class="buttons_controls prev swiper-button-prev"></a>`)
            $varieties.append(`<a class="buttons_controls next swiper-button-next"></a>`)

            $.each($items, function( i,val ){
                $container.append( $(this) )
            })
            
            this.slideVarieties = new Swiper('.Products__container__various', {
                nextButton: '.Products__container__various .swiper-button-next',
                prevButton: '.Products__container__various .swiper-button-prev',
                slidesPerView: itemsToShow,
                mousewheelControl: true,
                onSliderMove: function(){
                    console.log('slider moved')
                },
                breakpoints: {
                  642: {
                    slidesPerView: 1,
                    pagination: '.slide-pag',
                    paginationClickable: true,
                  }
                }
            })

            if( $varieties.find('.Variety.-block').length > 0 ){
                $varieties.find('.Variety.-block').css({
                    'height' : $items.first().outerHeight()
                })
            }
        }
        generatorSlide()

        $varieties.find('.Variety:not(.block)').on('click', function( event ){
            event.preventDefault()
            event.stopImmediatePropagation()

            if( $(this).hasClass('active') ){ return false }

            $(this)
                .addClass('active', 300, 'swing')
                .siblings()
                .removeClass('active', 300, 'swing')

            let indexToActive = $(this).index()

            let $details = $('.Products__container__details .Detail')
            $details.filter('.active').removeClass('active', 300, 'easeOutCubic')
            $details.eq( indexToActive ).addClass('active', 300, 'swing')
        })
        
        $(window).resize( ()=> {
            resizerBox()

            if( !$.isEmptyObject(self.slideVarieties) ){
                let itemsToShow = 0

                if( window.innerWidth >= 1200 ){
                    itemsToShow = 4
                } else if( window.innerWidth < 1200 && window.innerWidth >= 900 ){
                    itemsToShow = 3
                } else{
                    if( window.innerWidth >= 500 ){
                        itemsToShow = 2
                    } else{
                        itemsToShow = 1
                    }
                }

                if( self.slideVarieties.params.slidesPerView != itemsToShow ){
                    self.slideVarieties.params.slidesPerView = itemsToShow
                }

                self.slideVarieties.update()
            }

            if( $varieties.find('.Variety.-block').length > 0 ){
                $varieties.find('.Variety.-block').css({
                    'height' : $varieties.find('.Variety').first().outerHeight()
                })
            }
        })

        $(window).on("orientationchange", ()=> {
            resizerBox()

            if( !$.isEmptyObject(self.slideVarieties) ){
                let itemsToShow = 0

                if( window.innerWidth >= 1200 ){
                    itemsToShow = 4
                } else if( window.innerWidth < 1200 && window.innerWidth >= 900 ){
                    itemsToShow = 3
                } else{
                    if( window.innerWidth >= 500 ){
                        itemsToShow = 2
                    } else{
                        itemsToShow = 1
                    }
                }

                if( self.slideVarieties.params.slidesPerView != itemsToShow ){
                    self.slideVarieties.params.slidesPerView = itemsToShow
                }

                self.slideVarieties.update()
            }

            if( $varieties.find('.Variety.-block').length > 0 ){
                $varieties.find('.Variety.-block').css({
                    'height' : $varieties.find('.Variety').first().outerHeight()
                })
            }
        })
    }
}


